import * as React from 'react'
import { compose } from 'redux'
import { Router, Switch } from 'react-router'
import { connect } from 'react-redux'
// @ts-ignore
import { Snackbar } from 'react-redux-snackbar'
import history from '@App/helpers/history'
import routes from 'routes'
import { createRoutes } from 'helpers/configureRoutes'
import 'styles/styles.scss'
import AlertBlock from '@App/components/blocks/Alert'
import { AppState } from 'reducers'
import LoadingApp from '@App/components/blocks/LoadingApp'
// @ts-ignore
import to from 'await-to-js'

class App extends React.Component<any> {
  state: any

  constructor(props: any) {
    super(props)

    this.state = {
      isLoaded: window.localStorage.getItem('user') ? true : false,
    }
  }

  async componentDidMount() {
    const route = history.location.pathname

    if (
      route === '/' ||
      route === '/create-password' ||
      route === '/reset-password' ||
      route === '/recovery-password'
    ) {
      this.setState({
        isLoaded: true,
      })
    }
  }

  render() {
    const { alert } = this.props
    const route = history.location.pathname

    return (
      <div>
        <AlertBlock content={alert || {}} />
        <Router history={history}>
          <Switch>
            {createRoutes(routes)}
            <Snackbar
              customStyles={{
                snack: {
                  zIndex: 2147483647,
                  top: 0,
                  bottom: '',
                  transform: 'translate(0, 0)',
                  largeScreen: {
                    transform: 'translate(-50%, 0)',
                  },
                },
              }}
              theming={{
                transitionToXY: {
                  smallScreen: '0, 0',
                  largeScreen: '-50%, 0',
                },
              }}
            />
          </Switch>
        </Router>
        {
          route === '/' || route === '/create-password' || route === '/reset-password' || route === '/recovery-password' ? null : <LoadingApp active={this.state.isLoaded} />
        }
      </div>
    )
  }
}

const mapStateToProps = (state: AppState) => {
  const {
    snackbarReducer,
  } = state

  return {
    alert: snackbarReducer && snackbarReducer.alert,
  }
}

export default compose(
  connect(mapStateToProps, null),
)(App)
